import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=7273c49f&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=7273c49f&prod&lang=scss"
import style1 from "./profile.vue?vue&type=style&index=1&id=7273c49f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273c49f",
  null
  
)

export default component.exports